<!-- eslint-disable no-underscore-dangle -->
<script>
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';

    function createAsyncOptionsStates() {
        return {
            isLoaded: false,
            isLoading: false,
            loadingError: '',
        };
    }

    const createMap = function createMap() {
        return Object.create(null);
    };

    const clearObj = function clearObj(obj) {
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                delete obj[key]; // eslint-disable-line no-param-reassign
            }
        }
    };

    export default {
        name: 'VueTreeSelect',
        extends: Treeselect,
        methods: {
            getRemoteSearchEntry() {
                const { searchQuery } = this.trigger;
                const entry = this.remoteSearch[searchQuery] || {
                    ...createAsyncOptionsStates(),
                    options: [],
                };

                // Vue doesn't support directly watching on objects.
                // this.$watch(
                //     () => entry.options,
                //     () => {
                //         // TODO: potential redundant re-initialization.
                //         if (this.trigger.searchQuery === searchQuery) this.initialize();
                //     },
                //     { deep: false } // WYŁĄCZAMY DEEP WATCH!!!
                // );

                if (searchQuery === '') {
                    if (Array.isArray(this.defaultOptions)) {
                        entry.options = this.defaultOptions;
                        entry.isLoaded = true;
                        if (this.trigger.searchQuery === searchQuery) this.initialize(); // Przenosimy this.initialize() aby nie powielać inicjowania watch na entry.options
                        return entry;
                    }
                    if (this.defaultOptions !== true) {
                        entry.isLoaded = true;
                        return entry;
                    }
                }

                if (!this.remoteSearch[searchQuery]) {
                    this.$set(this.remoteSearch, searchQuery, entry);
                }

                return entry;
            },
            select: function select(node) {
                if (this.disabled || node.isDisabled) {
                    return;
                }

                if (this.single) {
                    this.clear();
                }

                const UNCHECKED = 0;

                const nextState = this.multiple && !this.flat ? this.forest.checkedStateMap[node.id] === UNCHECKED : !this.isSelected(node);

                if (nextState) {
                    this._selectNode(node);
                } else {
                    this._deselectNode(node);
                }

                this.buildForestState();

                if (nextState) {
                    this.$emit('select', node, this.getInstanceId()); // EMITUJEMY CAŁY "node", a nie jak w oryginale "node.raw"
                } else {
                    this.$emit('deselect', node, this.getInstanceId()); // EMITUJEMY CAŁY "node", a nie jak w oryginale "node.raw"
                }

                if (this.localSearch.active && nextState && (this.single || this.clearOnSelect)) {
                    this.resetSearchQuery();
                }

                if (this.single && this.closeOnSelect) {
                    this.closeMenu();

                    if (this.searchable) {
                        this._blurOnSelect = true;
                    }
                }
            },
            initialize: function initialize() {
                const options = this.async ? this.getRemoteSearchEntry().options : this.options;

                const NO_PARENT_NODE = null;

                if (Array.isArray(options)) {
                    const prevNodeMapRef = this.forest.nodeMap;
                    const prevNodeMap = { ...this.forest.nodeMap };
                    this.forest.nodeMap = createMap();
                    this.keepDataOfSelectedNodes(prevNodeMap);
                    this.forest.normalizedOptions = this.normalize(NO_PARENT_NODE, options, prevNodeMap);
                    this.fixSelectedNodeIds(this.internalValue);

                    // Odzyskujemy referencję do "this.forest.nodeMap"
                    clearObj(prevNodeMapRef);
                    for (const key1 in this.forest.nodeMap) {
                        if (prevNodeMap[key1]) {
                            clearObj(prevNodeMap[key1]);
                            for (const key2 in this.forest.nodeMap[key1]) {
                                prevNodeMap[key1][key2] = this.forest.nodeMap[key1][key2];
                            }
                            prevNodeMapRef[key1] = prevNodeMap[key1];
                        }
                    }
                } else {
                    this.forest.normalizedOptions = [];
                }
            },
        },
    };
</script>
